export default "https://cdn-static.gokick.com/assets/c678e0ba2e275fccd6b7b161f66793b4454cd3c4/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";